export default __webpack_public_path__ + "static/media/fahuo.9e201019.png";